import { render } from "./header-toolbar.vue?vue&type=template&id=2327db1a"
import script from "./header-toolbar.vue?vue&type=script&lang=js"
export * from "./header-toolbar.vue?vue&type=script&lang=js"

import "./header-toolbar.vue?vue&type=style&index=0&id=2327db1a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__